import React, { useState, useEffect, useContext } from "react";
import "./ClientEnquiryForm.css";
import { UserContext } from "../UserContext";
import axios from "axios";
import LabeledTextField from "./LabeledTextField";
import {
  Button,
  Snackbar,
  Alert,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Box,
  FormLabel,
  RadioGroup,FormGroup, Checkbox,
  FormControlLabel,
  Radio,
  OutlinedInput,
  Chip,
  Typography,
  IconButton,
} from "@mui/material";
import { Add } from '@mui/icons-material';


const ClientEnquiryForm = ({ onSubmitSuccess, edit, setEdit, steps, selectedStatus }) => {
  const { user_id } = useContext(UserContext);
  const [companyTypes, setCompanyTypes] = useState([]);
  const [callStatus, setCallStatus] = useState([]);
  const [enquriyStatus, setEnquriyStatus] = useState([]);
  const [industryTypes, setIndustryTypes] = useState([]);
  const [geolocation, setGeolocation] = useState({});
  const availableSteps = steps.slice(steps.indexOf(selectedStatus) + 1);

  // CHANGE: Initial state for multi-select fields MUST be an array.
  const [formData, setFormData] = useState({
    company_name: "",
    company_type: null,
    company_location: "",
    contact_person: "",
    mobile_number: "",
    currently_using_software: "",
    employee_strength: "",
    followup_date: "",
    is_using_service:"",
    call_status: "",
    needs: "",
    feedback: "",
    items_required: "",
    demands: "",
    industry_category: "",
    using_software_name: "",
    assigned_to: [], // <-- FIXED: Changed from "" to []
    product_id: [],
    enquiry_status: "",
    service_id: [],
    latitude: "28.641529",
    industry_type:null,
    isUsingSoftware:"",
    industry_category:"",
    business_type: [],
    longitude: "77.120918",
  });

  console.log("formData",formData)

  const [isUsingSoftware, setIsUsingSoftware] = useState("");
  const [isUsingService, setIsUsingService] = useState("");
  const [product, setProduct] = useState([]);
  const [service, setServices] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [messages, setMessages] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const [openAddCompanyType, setOpenAddCompanyType] = useState(false);
  const [openAddIndustryType, setOpenAddIndustryType] = useState(false);
  const [newCompanyType, setNewCompanyType] = useState('');
  const [newIndustryType, setNewIndustryType] = useState('');
useEffect(() => {
    setFormData(prevFormData => ({
        ...prevFormData,
        latitude: "28.641529",
        longitude: "77.120918"
    }));
}, []); // <-- 1. Add an empty dependency array
// Add this new handler function inside your component
const handleBusinessTypeChange = (event) => {
  const { value, checked } = event.target;
  setFormData(prev => {
    const currentTypes = prev.business_type || [];
    if (checked) {
      // If the box is checked, add the value to the array
      return { ...prev, business_type: [...currentTypes, value] };
    } else {
      // If the box is unchecked, remove the value from the array
      return { ...prev, business_type: currentTypes.filter(type => type !== value) };
    }
  });
};
  // CHANGE: Corrected function to populate form for editing
  const fetchEnquiryDetails = async () => {
    try {
      const response = await axios.get(`/api/client-enquiry/${edit?.id}/`);
      const data = response.data;

      setFormData({
        company_name: data.company_name || "",
        company_type: data.company_type || "",
        company_location: data.company_location || "",
        contact_person: data.contact_person || "",
        mobile_number: data.mobile_number || "",
        currently_using_software: data.currently_using_software || "",
        employee_strength: data.employee_strength || 0,
        followup_date: data.followup_date || "",
        needs: data.needs || "",
        feedback: data.feedback || "",
        items_required: data.items_required || "",
        demands: data.demands || "",
        using_software_name: data.using_software_name || "",
        industry_category: data.industry_category || "",
        industry_type: data.industry_type || "",
        is_using_service: data.is_using_service || "",
        isUsingSoftware: data.isUsingSoftware || "",
        
        // --- CRITICAL FIX ---
        // Use the list of IDs from the API. Provide a default empty array if it's null.
        assigned_to: data.assigned_to || [],
        business_type: data.business_type || [],

        // --- FIX for other multi-selects ---
        product_id: data.product_id || [],
        service_id: data.service_id || [],

        latitude: data.latitude || "",
        call_status: data.call_status || "",
        enquiry_status: data.enquiry_status || "",
        longitude: data.longitude || "",
      });
    } catch (err) {
      console.error("Error fetching enquiry details:", err);
    }
  };

  // This useEffect is for handling the edit mode. It's correct.
  useEffect(() => {
    if (edit !== null) {
      fetchEnquiryDetails();
    } else {
      // Reset form for a new entry
      setFormData({
        company_name: "", company_type: "", company_location: "", contact_person: "",
        mobile_number: "", currently_using_software: "", employee_strength: "",
        followup_date: "", needs: "", feedback: "", items_required: "", demands: "",
        assigned_to: [], // <-- Ensure reset is also an array
        product_id: [], service_id: [], latitude: "", longitude: "",
      });
    }
  }, [edit]); // Dependency on 'edit' is correct

  const [formValidity, setFormValidity] = useState({
    company_name: false, company_type: false, company_location: false,
    contact_person: false, mobile_number: false, employee_strength: false,
    followup_date: false, assigned_to: false,
  });

  const getGeolocation = () => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        setGeolocation({
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
        });
      },
      (error) => console.error("Error getting geolocation:", error)
    );
  };

  // CHANGE: Combined multiple useEffects into one for initial data fetching.
  // This is more efficient as it causes fewer re-renders on component mount.
  useEffect(() => {
    // Fetch all initial data needed for the form
    const fetchInitialData = async () => {
      try {
        const [
          companyTypesRes,
          callStatusRes,
          enquiryStatusRes,
          industryTypesRes,
          employeesRes,
          productsRes,
          servicesRes,
        ] = await Promise.all([
          axios.get("api/company-types/"),
          axios.get("api/call-status/"),
          axios.get("api/enquriy-status/"),
          axios.get("api/industry-types/"),
          fetch("/api/employees").then(res => res.json()),
          fetch("api/products/").then(res => res.json()),
          fetch("api/services/").then(res => res.json()),
        ]);

        setCompanyTypes(companyTypesRes.data);
        setCallStatus(callStatusRes.data);
        setEnquriyStatus(enquiryStatusRes.data);
        setIndustryTypes(industryTypesRes.data);
        setEmployees(employeesRes);
        setProduct(productsRes);
        setServices(servicesRes);
      } catch (error) {
        console.error("Error fetching initial data:", error);
      }
    };

    fetchInitialData();
    getGeolocation(); // Also get geolocation on mount
  }, []); // Empty dependency array means this runs only once

  // Update formData when geolocation changes
  useEffect(() => {
    setFormData((prev) => ({
      ...prev,
      latitude: geolocation.latitude || "",
      longitude: geolocation.longitude || "",
    }));
  }, [geolocation]);


  const handleAddCompanyType = async () => {
    try {
      await axios.post('/api/company-types/', { name: newCompanyType });
      setNewCompanyType('');
      setOpenAddCompanyType(false);
      fetchCompanyTypes(); // You would need to define this again or add to the combined fetch
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleAddIndustryType = async () => {
    try {
      await axios.post('/api/industry-types/', { name: newIndustryType });
      setNewIndustryType('');
      setOpenAddIndustryType(false);
      fetchIndustryTypes(); // Same as above
    } catch (error) {
      console.log(error);
    }
  };

  // Your handleChange is correct and will work now
  const handleChange = (e) => {
    const { name, value, type } = e.target;
    if (type === "checkbox") {
        const currentValues = formData[name] || [];
        const isChecked = e.target.checked;
        if (isChecked) {
            setFormData({ ...formData, [name]: [...currentValues, value] });
        } else {
            setFormData({ ...formData, [name]: currentValues.filter((item) => item !== value) });
        }
    } else {
        setFormData({ ...formData, [name]: value });
    }
    validateField(name, value);
  };

  const validateField = (name, value) => {
    let isValid = value !== "" && (Array.isArray(value) ? value.length > 0 : true);
    setFormValidity((prevValidity) => ({ ...prevValidity, [name]: isValid }));
  };

  const isFormValid = () => {
    return Object.values(formValidity).every(Boolean);
  };

  const handleServiceRadioButtonChange = (e) => {
    const value = e.target.value;
    setIsUsingService(value);
    setFormData({ ...formData, is_using_service: value });
  };

  const handleRadioButtonChange = (e) => {
    const value = e.target.value;
    setIsUsingSoftware(value);
    setFormData({ ...formData, isUsingSoftware: value });
  };
    const fetchIndustryTypes = async () => {
    try {
      const response = await axios.get("api/industry-types/");
      setIndustryTypes(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {

    fetchIndustryTypes();
  }, []);  const fetchCompanyTypes = async () => {
    try {
      const response = await axios.get("api/company-types/");
      setCompanyTypes(response.data);
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {

    fetchCompanyTypes();
  }, []);

const handleSubmit = async (e) => {
    e.preventDefault();

    const url = edit
        ? `api/client-enquiry/${edit?.id}/update/?user_id=${user_id}`
        : `api/post-client-enquiry/?created_by=${encodeURIComponent(user_id)}`;

    const method = edit ? "PUT" : "POST";

    // --- Create the initial payload, ensuring lat/lng are included ---
    let payload = {
        ...formData, // Include all existing form data
        latitude: "28.641529", // Explicitly set/override latitude
        longitude: "77.120918", // Explicitly set/override longitude
    };

    // --- NEW: Apply business logic before sending ---
    // If call_status is being set to "Not Interested", force enquiry_status to "Lose"
    if (payload.call_status === "Not Interested") {
        payload.enquiry_status = "Lost";
        payload.needs = selectedStatus
    }

    console.log("Submitting final payload:", payload); // Log the final payload to verify

    try {
        const response = await fetch(url, {
            method: method,
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(payload), // <-- Send the modified payload object
        });

        if (!response.ok) {
            // Try to get a more specific error message from the backend response
            const errorData = await response.json().catch(() => ({}));
            throw new Error(errorData.error || `HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        setSnackbarMessage(edit ? "Enquiry updated successfully!" : "Form submitted successfully!");
        setSnackbarSeverity("success");
        setSnackbarOpen(true);
        setEdit(null);
        onSubmitSuccess();

    } catch (error) {
        console.error("Error:", error);
        const errorMessage = error.message || "An unknown error occurred.";
        setSnackbarMessage(edit ? `Error updating enquiry: ${errorMessage}` : `Error submitting form: ${errorMessage}`);
        setSnackbarSeverity("error");
        setSnackbarOpen(true);
    }
};
  return (
    <div style={{ padding: 20 }}>
      <form onSubmit={handleSubmit}>
        {messages.length > 0 &&
          messages.map((message, index) => (
            <div key={index} className={`alert alert-${message.type}`}>
              {message.text}
            </div>
          ))}

        <div className="form-group">
          <div className="form-group-item11">
            <LabeledTextField
              label="Company Name"
              name="company_name"
              value={formData.company_name}
              onChange={handleChange}
              disabled={!!edit}
              focused
              required
            />
          </div>

          <FormControl fullWidth sx={{
            borderRadius: 2,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#fb7102',
                border: "2px solid #fb7102 ",
                borderRadius: "10px"
              },
              '&:hover fieldset': {
                borderColor: '#fb7102',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#fb7102',
              },
            },
          }}>
            <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
              Company Type
            </Typography>
            <Select
              name="company_type"
              value={formData.company_type}
              onChange={handleChange}
              required
              displayEmpty
            >
              <MenuItem value="" disabled>Select company type</MenuItem>
              {companyTypes.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
            </Select>
            <IconButton onClick={() => setOpenAddCompanyType(true)} sx={{ position: 'absolute', right: 0, top: 30 }}>
              <Add />
            </IconButton>
            {openAddCompanyType && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <TextField
                  value={newCompanyType}
                  onChange={(e) => setNewCompanyType(e.target.value)}
                  placeholder="Enter new company type"
                />
                <Button onClick={handleAddCompanyType} disabled={!newCompanyType.trim()}>Add</Button>
                <Button onClick={() => { setOpenAddCompanyType(false); setNewCompanyType(''); }}>Cancel</Button>
              </Box>
            )}
          </FormControl>
          <FormControl fullWidth sx={{
            borderRadius: 2,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#fb7102',
                border: "2px solid #fb7102 ",
                borderRadius: "10px"
              },
              '&:hover fieldset': {
                borderColor: '#fb7102',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#fb7102',
              },
            },
          }}>
            <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
              Industry Type
            </Typography>
            <Select
              name="industry_type"
              value={formData.industry_type}
              onChange={handleChange}
              required
              displayEmpty
            >
              <MenuItem value="" disabled>Select Industry type</MenuItem>
              {industryTypes.map((type) => (
                <MenuItem key={type.id} value={type.id}>
                  {type.name}
                </MenuItem>
              ))}
            </Select>
            <IconButton onClick={() => setOpenAddIndustryType(true)} sx={{ position: 'absolute', right: 0, top: 30 }}>
              <Add />
            </IconButton>
            {openAddIndustryType && (
              <Box sx={{ display: 'flex', alignItems: 'center', mt: 2 }}>
                <TextField
                  value={newIndustryType}
                  onChange={(e) => setNewIndustryType(e.target.value)}
                  placeholder="Enter new company type"
                />
                <Button onClick={handleAddIndustryType} disabled={!newIndustryType.trim()}>Add</Button>
                <Button onClick={() => { setOpenAddIndustryType(false); setNewIndustryType(''); }}>Cancel</Button>
              </Box>
            )}
          </FormControl>
          {formData.industry_type && (
  <FormControl fullWidth sx={{ 
    '& .MuiOutlinedInput-root': { // Apply the same border styling
      '& fieldset': {
        borderColor: '#fb7102',
        border: "2px solid #fb7102 ",
        borderRadius: "10px"
      },
      '&:hover fieldset': {
        borderColor: '#fb7102',
      },
      '&.Mui-focused fieldset': {
        borderColor: '#fb7102',
      },
    },
  }}>
    <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
      Industry Category
    </Typography>
    <TextField
      name="industry_category"
      value={formData.industry_category}
      onChange={handleChange}
      placeholder="e.g., B2B SaaS, E-commerce, Healthcare"
      variant="outlined" // Important for the fieldset styling to apply correctly
    />
  </FormControl>
)}
        </div>

        <div className="form-group">
          <div className="form-group-item">
            <LabeledTextField
              label="Company Location"
              name="company_location"
              value={formData.company_location}
              onChange={handleChange}
              required
            />
          </div>
          <div className="form-group-item">
            <LabeledTextField
              label="Contact Person"
              name="contact_person"
              value={formData.contact_person}
              onChange={handleChange}
              required
            />
          </div>
        </div>
 <div className="form-group">
        <div className="form-group-item">
            <LabeledTextField
              label="Email"
              name="items_required"
              value={formData.items_required}
              onChange={handleChange}
              type="email"
              rows={4}
              required
            />
          </div>
 <div className="form-group-item">

        <FormControl fullWidth sx={{
    borderRadius: 2,
    marginBottom: 4,
    '& .MuiOutlinedInput-root': {
        '& fieldset': {
            borderColor: '#fb7102',
            border: "2px solid #fb7102 ",
            borderRadius: "10px"
        },
        '&:hover fieldset': {
            borderColor: '#fb7102',
        },
        '&.Mui-focused fieldset': {
            borderColor: '#fb7102',
        },
    },
}}>
    <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
        Currently Using Software
    </Typography>
    <Select
        name="currently_using_software"
        value={formData.currently_using_software}
        onChange={handleChange}
        className="enquiry-form-input1"
        displayEmpty // Optional: good for showing a placeholder
    >
        {/* Use MenuItem instead of option */}
        <MenuItem value="Yes">Yes</MenuItem>
        <MenuItem value="No">No</MenuItem>
    </Select>
</FormControl>
</div>
</div>
{formData.currently_using_software === 'Yes' && (
    <FormControl fullWidth sx={{ 
        marginBottom: 4, // Consistent spacing
        '& .MuiOutlinedInput-root': { // Apply the same border styling
            '& fieldset': {
                borderColor: '#fb7102',
                border: "2px solid #fb7102 ",
                borderRadius: "10px"
            },
            '&:hover fieldset': {
                borderColor: '#fb7102',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#fb7102',
            },
        },
    }}>
        <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
            Software Name
        </Typography>
        <TextField
            name="using_software_name"
            value={formData.using_software_name}
            onChange={handleChange}
            placeholder="e.g., Salesforce, Trello"
            variant="outlined"
        />
    </FormControl>
)}

        <div className="form-group">
          <div className="form-group-item">
            <LabeledTextField
              label="Employee Strength"
              type="number"
              name="employee_strength"
              value={formData.employee_strength}
              onChange={handleChange}
              inputProps={{ min: 0 }}
              required
            />
          </div>
          <div className="form-group-item">
            <LabeledTextField
              label="FollowUp Date"
              type="datetime-local"
              name="followup_date"
              value={formData.followup_date}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        {/* <div className="form-group">
          <div className="form-group-item">
            <LabeledTextField
              label="Needs"
              name="needs"
              value={formData.needs}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </div>
          <div className="form-group-item">
            <LabeledTextField
              label="Demands"
              name="demands"
              value={formData.demands}
              onChange={handleChange}
              multiline
              rows={4}
            />
          </div>
        </div> */}

        <div className="form-group">
          
          <div className="form-group-item">
            <LabeledTextField
              label="Feedback"
              name="feedback"
              value={formData.feedback}
              onChange={handleChange}
              multiline
              rows={4}
              required
            />
          </div>
         <div className="form-group-item">
  <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 1, fontSize: "13px" }}>
    Business Type
  </Typography>
  <FormGroup row>
    <FormControlLabel
      control={
        <Checkbox
          value="B2B"
          checked={formData.business_type?.includes("B2B")}
          onChange={handleBusinessTypeChange}
          sx={{
            color: '#fb7102',
            '&.Mui-checked': {
              color: '#fb7102',
            },
          }}
        />
      }
      label="B2B"
    />
    <FormControlLabel
      control={
        <Checkbox
          value="B2C"
          checked={formData.business_type?.includes("B2C")}
          onChange={handleBusinessTypeChange}
          sx={{
            color: '#fb7102',
            '&.Mui-checked': {
              color: '#fb7102',
            },
          }}
        />
      }
      label="B2C"
    />
  </FormGroup>
</div>
                    <FormControl fullWidth sx={{
            borderRadius: 2,
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#fb7102',
                border: "2px solid #fb7102 ",
                borderRadius: "10px"
              },
              '&:hover fieldset': {
                borderColor: '#fb7102',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#fb7102',
              },
            },
          }}>
            <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
              Call Status
            </Typography>
            <Select
              name="call_status"
              value={formData.call_status}
              onChange={handleChange}
              required
              displayEmpty
            >
              <MenuItem value="" disabled>Select Call Status</MenuItem>
               {callStatus.map((status) => (
            <MenuItem key={status.value} value={status.value}>
                {status.label}
            </MenuItem>
        ))}
            </Select>
            </FormControl>
            {formData.call_status !== "Interested" &&(
              <div className="form-group-item">
            <LabeledTextField
              label="Command"
              name="demands"
              value={formData.demands}
              onChange={handleChange}
              multiline
              rows={4}
              required
            />
          </div>
            )}
<FormControl fullWidth sx={{
  borderRadius: 2,
  '& .MuiOutlinedInput-root': {
    '& fieldset': {
      borderColor: '#fb7102',
      border: "2px solid #fb7102 ",
      borderRadius: "10px"
    },
    '&:hover fieldset': {
      borderColor: '#fb7102',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#fb7102',
    },
  },
  // Add opacity when disabled
  opacity: formData.call_status !== "Interested" ? 0.6 : 1,
}}>
  <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
    Enquiry Status
  </Typography>
  <Select
    name="enquiry_status"
    value={formData.enquiry_status}
    onChange={handleChange}
    required
    displayEmpty
    disabled={formData.call_status !== "Interested"}
  >
    <MenuItem value="" disabled>Enquiry Status</MenuItem>
{availableSteps.map((step) => (
                        <MenuItem key={step} value={step}>
                            {step}
                        </MenuItem>
                    ))}
  </Select>
</FormControl>
        </div>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <FormControl>
            <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
              Product
            </Typography>
            <RadioGroup
              row
              name="isUsingSoftware"
              value={formData.isUsingSoftware}
              onChange={handleRadioButtonChange}
            >
              <FormControlLabel value="Yes" control={<Radio sx={{
                color: '#fb7102',
                '&.Mui-checked': {
                  color: '#fb7102',
                },
              }} />} label="Yes" />
              <FormControlLabel value="No" control={<Radio sx={{
                color: '#fb7102',
                '&.Mui-checked': {
                  color: '#fb7102',
                },
              }} />} label="No" />
            </RadioGroup>
          </FormControl>

          <FormControl>
            <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
              Service
            </Typography>
            <RadioGroup
              row
              name="is_using_service"
              value={formData.is_using_service}
              onChange={handleServiceRadioButtonChange}
            >
              <FormControlLabel
                value="Yes"
                control={
                  <Radio
                    sx={{
                      color: '#fb7102',
                      '&.Mui-checked': {
                        color: '#fb7102',
                      },
                    }}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value="No"
                control={
                  <Radio
                    sx={{
                      color: '#fb7102',
                      '&.Mui-checked': {
                        color: '#fb7102',
                      },
                    }}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </FormControl>
        </Box>

        {formData.isUsingSoftware === "Yes" && (
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth sx={{
              borderRadius: 2,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#fb7102',
                },
                '&:hover fieldset': {
                  borderColor: '#fb7102',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#fb7102',
                },
              },
            }}>
              <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
                Select products
              </Typography>
              <Select
                multiple
                name="product_id"
                value={formData.product_id}
                onChange={handleChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={product.find((p) => p.id === parseInt(value))?.product_name}
                      />
                    ))}
                  </Box>
                )}
              >
                {product.map((prod) => (
                  <MenuItem key={prod.id} value={prod.id}>
                    {prod.product_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}

        {isUsingService === "Yes" && (
          <Box sx={{ mb: 2 }}>
            <FormControl fullWidth sx={{
              borderRadius: 2,
              '& .MuiOutlinedInput-root': {
                '& fieldset': {
                  borderColor: '#fb7102',
                },
                '&:hover fieldset': {
                  borderColor: '#fb7102',
                },
                '&.Mui-focused fieldset': {
                  borderColor: '#fb7102',
                },
              },
            }}>
              <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
                Select Services
              </Typography>
              <Select
                multiple
                name="service_id"
                value={formData.service_id}
                onChange={handleChange}
                renderValue={(selected) => (
                  <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                    {selected.map((value) => (
                      <Chip
                        key={value}
                        label={service.find((s) => s.id === parseInt(value))?.service_name}
                      />
                    ))}
                  </Box>
                )}
              >
                {service.map((serv) => (
                  <MenuItem key={serv.id} value={serv.id}>
                    {serv.service_name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        )}

        <Box sx={{ mb: 2 }}>
          <FormControl fullWidth sx={{
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#fb7102',
              },
              '&:hover fieldset': {
                borderColor: '#fb7102',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#fb7102',
              },
            },
          }}>
            <Typography variant="subtitle2" gutterBottom sx={{ color: 'grey', fontWeight: 'bold', mb: 0.5, borderRadius: 2, fontSize: "13px" }}>
              Assigned To
            </Typography>
            <Select
              name="assigned_to"
              value={formData.assigned_to}
              onChange={handleChange}
              required
              multiple
            >
              <MenuItem value="">Select an employee</MenuItem>
              {employees.map((employee) => (
                <MenuItem key={employee.id} value={employee.id}>
                  {employee.first_name} {employee.last_name} - {employee.role}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Button
          type="submit"
          color="secondary"
          variant="contained"

          sx={{
            width: "100%",
            padding: "10px",
            fontSize: "18px",
            fontWeight: "bold",
            color: "#ffffff",
            background: "#fb7102",
            borderRadius: "8px",
            "&:hover": { background: "#fb7102" },
            "&:disabled": { background: "#cccccc", cursor: "not-allowed" },
          }}
        >
          Submit
        </Button>
      </form>

      <Snackbar
        open={snackbarOpen}
        autoHideDuration={5000}
        onClose={() => setSnackbarOpen(false)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        sx={{ "& .MuiSnackbarContent-root": { minWidth: 300 } }}
      >
        <Alert
          onClose={() => setSnackbarOpen(false)}
          severity={snackbarSeverity}
          sx={{ padding: "16px", fontSize: "1.2rem" }}
        >
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </div>
  );
};

export default ClientEnquiryForm;